import { render, staticRenderFns } from "./WorkBench.vue?vue&type=template&id=0605ff5e"
import script from "./WorkBench.vue?vue&type=script&lang=js"
export * from "./WorkBench.vue?vue&type=script&lang=js"
import style0 from "./WorkBench.vue?vue&type=style&index=0&id=0605ff5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports